export default {
  DIRECT_PRINTED: 'DIRECT_PRINTED',
  THREE_D_PRINTED: 'THREE_D_PRINTED',
  HOLLOW_D_PRINTED: 'HOLLOW_D_PRINTED',
} as const
